import React from 'react';
import styled from 'styled-components';
import { spaceMixin, Alert } from '@zillow/constellation';
var StyledErrorBox = styled.div.withConfig({
  displayName: "ErrorBox__StyledErrorBox",
  componentId: "sc-24rnzl-0"
})(["margin:", " auto;"], function (_ref) {
  var hideTopMargin = _ref.hideTopMargin;
  return hideTopMargin ? 0 : spaceMixin('sm');
});

var ErrorBox = function ErrorBox(_ref2) {
  var errorMessage = _ref2.errorMessage,
      _ref2$hideTopMargin = _ref2.hideTopMargin,
      hideTopMargin = _ref2$hideTopMargin === void 0 ? false : _ref2$hideTopMargin;
  return /*#__PURE__*/React.createElement(StyledErrorBox, {
    "data-testid": "error-message",
    hideTopMargin: hideTopMargin
  }, /*#__PURE__*/React.createElement(Alert, {
    appearance: "error",
    body: errorMessage
  }));
};

export default ErrorBox;
//# sourceMappingURL=ErrorBox.js.map